/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

    interface IParsedLimits {
        timeRange: LimitDateTimeRangeType;
        amount: number;
        timeRangeLabel: string;
    }
    export function getDateLimits(scope) {
        let limits: IParsedLimits = {
            timeRange: undefined,
            amount: 0,
            timeRangeLabel: undefined
        };
        if (scope.limitDateRangeTo) {
            limits = parseLimitDateRangeToValue(scope.limitDateRangeTo);
        }

        function businessMoment(scope) {
            if (scope['timeZoneOffset'] && scope['timeZoneOffset'] !== '') {
                let localUtcOffset = moment().utcOffset();
                let businessUtcOffset = moment().utcOffset(scope.timeZoneOffset).utcOffset();
                let businessOffsetFromLocal = businessUtcOffset - localUtcOffset;
                return moment().add('minutes', businessOffsetFromLocal);
            }
            return moment();
        }

        let minDate: Date;
        let maxDate: Date;
        switch (scope.runReportFor) {
            case 'PastToday':
                maxDate = businessMoment(scope).endOf('day').toDate();
                break;
            case 'PastNotToday':
                maxDate = businessMoment(scope).add(-1, 'days').endOf('day').toDate();
                break;
            case 'PastNotTodayAndYesterday':
                maxDate = businessMoment(scope).add(-2, 'days').endOf('day').toDate();
                break;
            case 'FutureToday':
                minDate = businessMoment(scope).startOf('day').toDate();
                break;
            case 'FutureNotToday':
                minDate = businessMoment(scope).add(1, 'days').startOf('day').toDate();
                break;
        }

        return {
            timeRange: limits.timeRange,
            timeRangeAmount: limits.amount,
            timeRangeLabel: limits.timeRangeLabel,
            minDate,
            maxDate,
        };
    }

    export class MeevoMonthYearRangePicker implements angular.IDirective {
        restrict = "E";
        scope = {
            fromDate: '=?',
            toDate: '=?',
            runReportFor: '@?',
            limitDateRangeTo: '@?',
            minDate: '=?',
            maxDate: '=?',
            timeZoneOffset: '=?',
        };

        templateUrl = "app/components/controls/monthYearRangePickerTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            const dateLimits = getDateLimits(scope);
            scope.timeRange = dateLimits.timeRange;
            scope.timeRangeAmount = dateLimits.timeRangeAmount;
            scope.timeRangeLabel = dateLimits.timeRangeLabel;
            const minDate = dateLimits.minDate;
            const maxDate = dateLimits.maxDate;

            scope.maxDate = maxDate || scope.maxDate || moment().add(100, 'years').toDate();
            scope.minDate = minDate || scope.minDate || moment().subtract(100, 'years').toDate();

            const maxYear = moment(scope.maxDate).year();
            const minYear = moment(scope.minDate).year();
            scope.yearList = _.range(maxYear, minYear - 1, -1);

            const maxMonth = moment(scope.maxDate).month();
            const minMonth = moment(scope.minDate).month();

            scope.monthFromList = this.getMonthList();
            scope.monthToList = this.getMonthList();

            scope.isInvalidRange = false;

            scope.checkIfValidRange = () => {
                if (scope.timeRange) { 
                    const dateDiff = moment(scope.toDate).diff(moment(scope.fromDate), scope.timeRange, true);
                    scope.isInvalidRange = dateDiff > scope.timeRangeAmount;
                }
            }

            scope.changeFrom = () => {
                if (scope.yearFromModel === maxYear) {
                    scope.monthFromList.forEach(month => month.isDisabled = month.index > maxMonth + 1);
                    if (scope.monthFromList[scope.monthFromModel - 1].isDisabled) {
                        scope.monthFromModel = maxMonth + 1;
                    }
                } else if (scope.yearFromModel === minYear) {
                    scope.monthFromList.forEach(month => month.isDisabled = month.index < minMonth + 1);
                    if (scope.monthFromList[scope.monthFromModel - 1].isDisabled) {
                        scope.monthFromModel = minMonth + 1;
                    }
                } else {
                    scope.monthFromList.forEach(month => month.isDisabled = false)
                }
                scope.fromDate = moment().set('month', scope.monthFromModel - 1)
                                         .set('year', scope.yearFromModel)
                                         .startOf('month').toDate();
                scope.checkIfValidRange();
            }

            scope.changeTo = () => {
                if (scope.yearToModel === maxYear) {
                    scope.monthToList.forEach(month => month.isDisabled = month.index > maxMonth + 1);
                    if (scope.monthToList[scope.monthToModel - 1].isDisabled) {
                        scope.monthToModel = maxMonth + 1;
                    }
                } else if (scope.yearToModel === minYear) {
                    scope.monthToList.forEach(month => month.isDisabled = month.index < minMonth + 1);
                    if (scope.monthToList[scope.monthToModel - 1].isDisabled) {
                        scope.monthToModel = minMonth + 1;
                    }
                } else {
                    scope.monthToList.forEach(month => month.isDisabled = false)
                }
                scope.toDate = moment().set('month', scope.monthToModel - 1)
                                       .set('year', scope.yearToModel)
                                       .endOf('month').toDate();
                scope.checkIfValidRange();
            }

            let defaultDate = moment().toDate();
            if (scope.fromDate) {
                defaultDate = scope.fromDate;
            } else {
                if (scope.maxDate  < defaultDate) {
                    defaultDate = scope.maxDate;
                } else if (scope.minDate > defaultDate) {
                    defaultDate = scope.minDate;
                }
            }
            scope.monthFromModel = scope.monthToModel = moment(defaultDate).month() + 1;
            scope.yearFromModel = scope.yearToModel =  moment(defaultDate).year();
            scope.changeFrom();
            scope.changeTo();
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoMonthYearRangePicker();
            };

            return directive;
        }

        getMonthList() {
            var months = _.range(1, 13);
            return _.map(months, (month: any) => ({
                index: month,
                label: moment(month, 'M').format('MMMM'),
                isDisabled: false,
            }));
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMonthYearRangePicker", MeevoMonthYearRangePicker.factory());
}
